import styled from 'styled-components';

import { TabContainer, TabsStyle } from 'components/tabs';

import theme from '../constants/theme';

export const TabsBarWrapper = styled.div`
  background-color: ${theme.tabBackground};
  width: 100%;
  padding: 0 1rem;

  ${Styles.desktop`
    display: flex;
    justify-content: center;
    padding: 0;
  `}

  ${TabsStyle} {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  ${TabContainer} {
    ${Styles.desktop`
      max-width: 350px;
  `}
  }
`;
